import { Component, Input, OnInit } from '@angular/core';
import { Label, PersonaArray, Sublabel } from 'app/shared/models/Label-Persona/label-persona';
import { LabelItemPersona } from 'app/shared/models/Persona/persona';
import { DataService } from 'app/shared/services/data/data.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';


@Component({
  selector: 'app-label-persona',
  templateUrl: './label-persona.component.html',
  styleUrls: ['./label-persona.component.scss']
})
export class LabelPersonaComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() listProfilUser: LabelItemPersona[];
  @Input() set items(value: any) {
    this.copyListWithId = value;
    this.copyList = value;
  }
  @Input() set name(value: string) {
    this.copyName = value;
    this.getLabel();
  }

  @Input() index: number;

  copyList: Sublabel[];
  copyListWithId: any;
  copyName: string;
  label: Label;
  personaArray: PersonaArray[];

  panelOpenState = false;
  allComplete = false;

  constructor(
    private dataService: DataService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.convertLabelItemPersonaToPersonaArray();
    this.initSub();
    this.copyList = this.convetToSublabelModel(this.copyList);
    this.getLabel();
  }


  updateAllComplete(): void {
    this.allComplete = this.label.sublabels != null && this.label.sublabels.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.label?.sublabels == null) {
      return false;
    }
    return this.label?.sublabels?.filter(t => t?.completed)?.length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.label.sublabels == null) {
      return;
    }
    this.label.sublabels.forEach(t => t.completed = completed);
  }

  addOrRemoveToPersonaSelected(persona: string): void {
    this.personaArray.forEach(item => {
      if (item.name === this.copyName) {
        const index = item.elements.findIndex(obj => obj.name === persona);
        if (index === -1) {
          this.copyListWithId.forEach(it => {
            if (it.name === persona) {
              item.elements.push(it);
            }
          });
        } else {
          item.elements.splice(index, 1);
        }
      }
    });
    this.dataService.arrayPersonas.next(this.personaArray);
  }

  addOrRemoveToPersonaSelectedAll(): void {
    let list: PersonaArray;

    this.personaArray.forEach(l => {
      if (l.name === this.copyName) {
        list = l;
      }
    });

    if (this.allComplete === true) {
      this.copyListWithId.forEach(item => {
        const index = list.elements.findIndex(obj => obj.name === item.name);
        if (index === -1) {
          list.elements.push(item);
        }
      });
    } else {
      this.personaArray.forEach(item => {
        if (item.name === this.copyName) {
          item.elements = [];
        }
      });
    }
    this.dataService.arrayPersonas.next(this.personaArray);
  }

  private convetToSublabelModel(value): Sublabel[] {
    const sublabel = [];
    let list: LabelItemPersona;

    this.listProfilUser.forEach(l => {
      l.items.forEach((item, index) => {
        // if (item.name === 'Inscrit') {
        //   l.items.splice(index, 1);

        // }
        // if (item.name === 'Licencié') {
        //   l.items.splice(index, 1);
        // }
      });
      if (l.name === this.copyName) {
        list = l;
      }
    });

    if (value !== undefined && this.listProfilUser !== undefined) {

      value.forEach(item => {
        const index = list.items?.findIndex(obj => obj.name === item.name);

        let sbl: Sublabel;

        if (index === -1) {
          sbl = {
            name: item.name,
            completed: false
          };
        } else {

          sbl = {
            name: item.name,
            completed: true
          };
        }

        sublabel.push(sbl);
      });
    }
    return sublabel;
  }

  private convertLabelItemPersonaToPersonaArray(): void {
    const array: PersonaArray[] = [];
    this.listProfilUser.forEach(item => {
      const list = {
        name: item.name,
        elements: item?.items
      };
      array.push(list);
    });
    this.dataService.arrayPersonas.next(array);
  }

  private getLabel(): void {
    this.label = {
      name: this.copyName,
      completed: this.allComplete,
      color: 'primary',
      sublabels: this.copyList
    };
    this.label?.sublabels?.forEach((item, index) => {
      if (item.name === 'Licencié') {
        this.label?.sublabels?.splice(index, 1);
      }
      if (item.name === 'Inscrit') {
        this.label?.sublabels?.splice(index, 1);
      }
      if (item.name === 'Public') {
        this.label?.sublabels?.splice(index, 1);
      }
    });

    // this.someComplete();
    this.updateAllComplete();
  }

  private initSub(): void {
    this.subscription.add(
      this.dataService.arrayPersonas.asObservable().subscribe(persona => {
        this.personaArray = persona;
        this.personaArray.forEach(list => {
          if (list.name === this.copyName) {
            if (list.elements.length === this.copyList.length) {
              this.allComplete = true;
            }
          }
        });
      })
    );
  }
}
